// extracted by mini-css-extract-plugin
export default {"richText":"ProposalRichText_richText__8pr7u","boxStyled":"ProposalRichText_boxStyled__k5SRP","proposalTitle":"ProposalRichText_proposalTitle__QXGWU"};